<template>
  <b-modal 
    :hide-footer="true" 
    :centered="true" 
	modal-class="modal-curso-detalle"
    id="modal-curso-detalle"
    size="lg"
	scrollable
  >
  	<template #modal-header="{ close }">
		<img class="close" src="@/assets/img/close_red.png" @click="close()">
		<h6 class="sub-title" v-if="programInfo">{{programInfo.title + " "}}<span class="sub-title-modal" v-if="levelInfo">({{datosCurso.level}})</span></h6>
	</template>
	<template v-if="programInfo">
    <div class="description">
		 <img :src="getImgObjetivoUrl(cursosJson.cursos.find(el => el.id == datosCurso.programId) != null ? cursosJson.cursos.find(el => el.id == datosCurso.programId).image : 'Objetivo 2.png')" class="img-box"/>
			<div class="text">
				<p>{{programInfo.description}}</p>
				<p v-if="programInfo.description2">{{programInfo.description2}}</p>
			</div>
		</div>
		<div class="card section_structure" v-if="levelInfo">
					<!-- <div class="structure">
						<div class="division" v-for="(level, i) in programInfo.levels" :key="level.code" :id="'level_'+level.code" :class="[level.grades.length > 1 ? 'd-flex' : '',level.grades.length > 1 ? 'dotted' : '']">
							<div class="block-1" v-if="level.grades.length > 1" :class="level.code === datosCurso.level ? 'active' : null">
								<div class="box" :class="[programInfo.title==programa_InglesNiños ? 'gd-n-'+(i+1) :'gd-'+(i+1) ]">
									<h1>{{level.code}} <span>{{level.title}}</span></h1>
								</div>
							</div>
							<div class="block-2">
							<div class="block" :class="level.code === datosCurso.level && (grade.code == datosCurso.grade || grade.code == '') ? 'active' : null"  v-for="grade in level.grades" :key="grade.code" :id="'grade_'+grade.code">
									<div class="box" v-if="level.grades.length > 1" :class="[programInfo.title==programa_InglesNiños ? 'gd-n-'+(i+1) :'gd-'+(i+1) ]">
										<h6>{{grade.title}}</h6>
									</div>
									<div class="box" :class="[programInfo.title==programa_InglesNiños ? 'gd-n-'+(i+1) :'gd-'+(i+1) ]" v-else>
										<h1>{{level.code}} <span>{{level.title}}</span></h1>
									</div>
									<ol>
										<li v-for="module in grade.modules" :key="module.name" :id="'module_'+module.name" :class="'border-gd-'+(i+1)">{{module.name}}<icon name="arrow-right-2" /></li>
									</ol>
								</div>
							</div>
						</div>
						
					</div> -->
					<h6>{{$t('planesYPrecios.paso-4.modal-curso.estructura.titulo')}}</h6>
					<!--<p>{{programInfo.structure}}</p>-->
					<img :src="getImgObjetivoUrl(cursosJson.cursos.find(el => el.id == datosCurso.programId) != null ? cursosJson.cursos.find(el => el.id == datosCurso.programId).structureImg : 'general-english-en.png')" />
					<!-- <div class="content">
						
					</div> -->
		</div>
		<div class="section_gray" v-if="levelInfo">
			<h6 class="sub-title">{{$t('planesYPrecios.paso-4.modal-curso.titulo2')}}<span>{{datosCurso.level}} {{$t('planesYPrecios.paso-4.modal-curso.subTitulo2')}}</span></h6>
			<b-row>
				<b-col cols="5">
					<ul >
						<li v-for="(el, index) in Math.ceil(levelInfo.afterLevel.length/2)" :key="index" :id="'materiales_div1_'+index">{{levelInfo.afterLevel[index].name}}</li>
					</ul>
				</b-col>
				<b-col cols="7">
					<ul>
						<li v-show="(index + Math.ceil(levelInfo.afterLevel.length/2)) < levelInfo.afterLevel.length" v-for="(el, index) in Math.ceil(levelInfo.afterLevel.length/2)" :key="index" :id="'materiales_div2_'+(index + Math.ceil(levelInfo.afterLevel.length/2))">{{ levelInfo.afterLevel[index + Math.ceil(levelInfo.afterLevel.length/2)] != null  ? levelInfo.afterLevel[index + Math.ceil(levelInfo.afterLevel.length/2)].name : ""}}</li>
					</ul>
				</b-col>
			</b-row>
		</div>
		<div class="materials" v-if="levelInfo">
			<b-row>
				<b-col cols="5" class="border-right">
					<h6>{{$t('planesYPrecios.paso-4.modal-curso.materiales.titulo')}}</h6>
					<ul>
						<li v-for="item in programInfo.materials" :key="item.id" :id="'materiales_div1_'+item.id">{{item.name}}</li>
					</ul>
				</b-col>
				<b-col class="pl-5">
					<h6>{{$t('planesYPrecios.paso-4.modal-curso.pregunta.titulo')}}</h6>
					<p>{{programInfo.rules}}</p>
				</b-col>
			</b-row>
		</div>
		</template>
  </b-modal>
</template>

<script>
import  cursosJson  from '@/locales/material/cursos-es.json';
import  cursosJsonEN  from '@/locales/material/cursos-en.json';
import { CONSTANTES} from '@/assets/js/appConstants'; 

export default {
	data() {
		return {
			API_URL: process.env.VUE_APP_API_URL,
			programInfo: null,
			levelInfo: null,
			cursosJson: localStorage.getItem('lang') == 'es' || localStorage.getItem('lang') ==  null ? cursosJson : cursosJsonEN,
			programa_InglesNiños: cursosJson.cursos.find(el => el.id == CONSTANTES.PROGRAMA_INGLES_NIÑOS).title
			
		}
	},
	props: {
		datosCurso: {
			type: Object,
		}
	},
	watch: { 
    	datosCurso: function(newVal, oldVal) { // watch it

			if(newVal != null){
				this.getSubjectInfo();
			}
		}
	},
	created() {
		
	},
  	methods:{
		getSubjectInfo: function() {
			
			let _cursosJson = localStorage.getItem('lang') == 'es' || localStorage.getItem('lang') ==  null ? cursosJson : cursosJsonEN;
			
			this.programInfo = _cursosJson.cursos.find(el => el.id === this.datosCurso.programId);
		
			this.levelInfo = null;
			if(this.programInfo != null && this.programInfo.levels != null){
				this.levelInfo = this.programInfo.levels.find(el => el.code === this.datosCurso.level);
				
			}
       
        },
		getImgObjetivoUrl(name) {
		 
			if(name != null){
				let codeObjImg =  name.replaceAll("0", "")
				return  require(`@/assets/img/${codeObjImg}`);
			}else{
				return null;
			}
		},
		/*openModal(){
            this.$bvModal.show('modal-curso-detalle');
        }*/
    }
}
</script>